import { createComponent } from '@carvana/merch-components';
import styled from 'styled-components';
import SelectionIndicator from '@/vdp/SelectionIndicator';
import { stickyBannerHeightDesktop } from '@/vdp/StickyBanner/BannerStyles';
import { desktopNavHeight } from './constants';
import SmoothAnchor from './SmoothAnchor';

export const DesktopPageNavigationWrapper = styled.div.attrs({
  className: 'relative'
})`
  & > span:first-of-type {
    position: absolute;
    top: 0;
  }
`;

export const DesktopStickyPageNavigationWrapper = createComponent('div', {
  className: 'sticky inset-x-0 z-[100] w-full',
  style: { top: stickyBannerHeightDesktop }
});

export const DesktopStickyPageNavigationInnerWrapper = styled.div.attrs({
  className: 'bg-white px-32 grid max-w-[1800px] mx-auto',
  style: { height: desktopNavHeight }
})<{ isSticky?: boolean }>`
  grid-template: 1fr / 70px 1fr 70px;

  &.box-shadow {
    box-shadow: 0 3px 21px rgba(0, 0, 0, 0.14);
  }
`;

const NavigationColumn = createComponent('div', {
  className: 'flex items-center'
});

export const NavigationColumnOne = createComponent(NavigationColumn, {
  className: 'justify-start'
});

export const NavigationColumnTwo = createComponent(NavigationColumn, {
  className: 'flex-1 justify-center'
});

export const NavigationButton = createComponent('a', {
  className: 'flex flex-nowrap items-center justify-center bg-transparent'
});

export const NavigationTab = createComponent(SmoothAnchor, {
  className: 'relative mx-16 flex h-full items-center justify-center',
  'data-qa': 'navigation-tab'
});

export const NavigationTabIndicator = createComponent(SelectionIndicator, {
  className: 'w-full'
});

export const NavigationText = createComponent('p', {
  className: 'uppercase text-blue-6 tl-header-xs',
  'data-qa': 'navigation-text'
});
